(function () {
  var SECTION_SELECTOR = '.oddit-search';
  var sectionCleanups = new WeakMap();

  function initSection(section) {
    var productList = section.querySelector('.oddit-search__product-list');
    var progressFill = section.querySelector('.oddit-search__progress-bar-fill');
    var cleanupFns = [];

    if (productList && progressFill) {
      var rafId = null;
      var onScroll = function () {
        if (rafId) return;
        rafId = requestAnimationFrame(function () {
          updateProgressBar(productList, progressFill);
          rafId = null;
        });
      };

      updateProgressBar(productList, progressFill);
      productList.addEventListener('scroll', onScroll, { passive: true });
      cleanupFns.push(function () {
        productList.removeEventListener('scroll', onScroll);
        if (rafId) cancelAnimationFrame(rafId);
      });
    }

    var closeBtn = section.querySelector('[data-search-close]');
    if (closeBtn) {
      var onClose = function () {
        closeSearch(section);
      };
      closeBtn.addEventListener('click', onClose);
      cleanupFns.push(function () {
        closeBtn.removeEventListener('click', onClose);
      });
    }

    var onKeydown = function (e) {
      if (e.key === 'Escape' && section.classList.contains('is-open')) {
        closeSearch(section);
      }
    };
    document.addEventListener('keydown', onKeydown);
    cleanupFns.push(function () {
      document.removeEventListener('keydown', onKeydown);
    });

    /* Click outside the cream content panels (i.e. on the dim overlay area)
       closes the search. */
    var searchBar = section.querySelector('.oddit-search__search-bar-container');
    var searchMain = section.querySelector('.oddit-search__main');
    var onSectionClick = function (e) {
      if (!section.classList.contains('is-open')) return;
      if (searchBar && searchBar.contains(e.target)) return;
      if (searchMain && searchMain.contains(e.target)) return;
      closeSearch(section);
    };
    section.addEventListener('click', onSectionClick);
    cleanupFns.push(function () {
      section.removeEventListener('click', onSectionClick);
    });

    var searchInput = section.querySelector('[data-search-input]');
    var suggestionsList = section.querySelector('.oddit-search__suggestions-list');
    var liveProductList = section.querySelector('.oddit-search__product-list');
    if (searchInput && (suggestionsList || liveProductList)) {
      var resourceTypes = section.getAttribute('data-search-resource-types') || 'product,collection,article,page';
      var resultsLimit = parseInt(section.getAttribute('data-search-results-limit'), 10) || 4;
      var suggestionLimit = 6;
      var hoverUnderline = suggestionsList && suggestionsList.querySelector('.oddit-hover-underline') ? ' oddit-hover-underline' : '';
      var hoverZoom = liveProductList && liveProductList.querySelector('.oddit-hover-zoom') ? ' oddit-hover-zoom' : '';

      // Preserve the curated (Liquid-rendered) defaults so we can restore them.
      section.__odditSearchDefaults = {
        suggestions: suggestionsList ? suggestionsList.innerHTML : '',
        products: liveProductList ? liveProductList.innerHTML : ''
      };

      var debounceTimer = null;
      var controller = null;

      var doSearch = function (q) {
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=' + encodeURIComponent(resourceTypes) +
          '&resources[limit]=' + resultsLimit +
          '&resources[options][unavailable_products]=last';

        var opts = {};
        if (window.AbortController) {
          if (controller) controller.abort();
          controller = new AbortController();
          opts.signal = controller.signal;
        }

        fetch(url, opts)
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (data) {
            if (!data) return;
            var r = (data.resources && data.resources.results) || {};
            var products = r.products || [];

            if (suggestionsList) {
              var seen = {};
              var suggestions = [];
              ['products', 'collections', 'articles', 'pages'].forEach(function (key) {
                (r[key] || []).forEach(function (item) {
                  var title = (item.title || '').trim();
                  var dedupeKey = title.toLowerCase();
                  if (title && item.url && !seen[dedupeKey] && suggestions.length < suggestionLimit) {
                    seen[dedupeKey] = true;
                    suggestions.push({ title: title, url: item.url });
                  }
                });
              });
              renderSuggestions(suggestionsList, suggestions, hoverUnderline);
            }

            if (liveProductList) {
              renderProducts(liveProductList, products, hoverZoom);
            }
          })
          .catch(function () { /* aborted or network error — ignore */ });
      };

      var onSearchInput = function () {
        var q = searchInput.value.trim();
        clearTimeout(debounceTimer);
        if (q.length < 2) {
          restoreSearchDefaults(section);
          return;
        }
        debounceTimer = setTimeout(function () { doSearch(q); }, 250);
      };

      searchInput.addEventListener('input', onSearchInput);
      cleanupFns.push(function () {
        searchInput.removeEventListener('input', onSearchInput);
        clearTimeout(debounceTimer);
        if (controller) controller.abort();
      });
    }

    sectionCleanups.set(section, function () {
      cleanupFns.forEach(function (fn) { fn(); });
    });
  }

  function openSearch(section) {
    section.style.display = '';
    section.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    /* Anchor the overlay just below the bottom edge of the sticky header so
       the header (and the announcement bar above it, when present) stay
       visible. Body scroll is locked while open, so this one-time read is
       enough. */
    var header = document.querySelector('.oddit-header');
    if (header) {
      var headerBottom = Math.max(0, header.getBoundingClientRect().bottom);
      section.style.top = headerBottom + 'px';
      section.style.height = 'calc(100vh - ' + headerBottom + 'px)';
    }

    var input = section.querySelector('[data-search-input]') || section.querySelector('.oddit-search__input');
    if (input) {
      requestAnimationFrame(function () {
        input.focus();
      });
    }
  }

  function closeSearch(section) {
    section.classList.remove('is-open');
    section.style.display = 'none';
    section.style.top = '';
    section.style.height = '';
    document.body.style.overflow = '';

    var input = section.querySelector('[data-search-input]') || section.querySelector('.oddit-search__input');
    if (input) input.value = '';

    // Reset the columns to their curated defaults for the next open.
    restoreSearchDefaults(section);
  }

  function destroySection(section) {
    var cleanup = sectionCleanups.get(section);
    if (cleanup) {
      cleanup();
      sectionCleanups.delete(section);
    }
  }

  function updateProgressBar(scrollContainer, fillElement) {
    var scrollWidth = scrollContainer.scrollWidth - scrollContainer.clientWidth;
    if (scrollWidth <= 0) {
      fillElement.style.width = '100%';
      return;
    }
    var scrollPercent = (scrollContainer.scrollLeft / scrollWidth) * 100;
    var minFill = 33;
    var fillWidth = minFill + (scrollPercent / 100) * (100 - minFill);
    fillElement.style.width = fillWidth + '%';
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* Predictive search returns price as a dollar string (e.g. "20.00").
     Drop the trailing ".00" to match the site-wide price formatting. */
  function formatPrice(priceStr) {
    var n = parseFloat(priceStr);
    if (isNaN(n)) return '';
    var cents = Math.round(n * 100);
    return '$' + (cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2));
  }

  function sizedImage(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function renderSuggestions(container, items, hoverClass) {
    if (!items.length) {
      container.innerHTML = '<p class="oddit-search__empty">No suggestions found.</p>';
      return;
    }
    var html = '';
    for (var i = 0; i < items.length; i++) {
      if (i > 0) html += '<hr class="oddit-search__divider" aria-hidden="true" />';
      html += '<a href="' + items[i].url + '" class="oddit-search__suggestion-item' + hoverClass + '">' +
        escapeHtml(items[i].title) + '</a>';
    }
    container.innerHTML = html;
  }

  function renderProducts(container, products, hoverClass) {
    if (!products.length) {
      container.innerHTML = '<p class="oddit-search__empty">No products found.</p>';
      return;
    }
    var html = '';
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var imgUrl = (p.featured_image && p.featured_image.url) || p.image || '';
      var alt = escapeHtml((p.featured_image && p.featured_image.alt) || p.title || '');
      var price = formatPrice(p.price);
      html += '<article class="oddit-search__product-card' + hoverClass + '">' +
        '<a href="' + p.url + '" class="oddit-search__product-link">' +
          '<div class="oddit-search__product-image-wrapper' + hoverClass + '">' +
            (imgUrl ? '<img src="' + sizedImage(imgUrl, 280) + '" alt="' + alt + '" class="oddit-search__product-image" loading="lazy" />' : '') +
          '</div>' +
          '<div class="oddit-search__product-details">' +
            '<p class="oddit-search__product-name">' + escapeHtml(p.title) + '</p>' +
            (price ? '<p class="oddit-search__product-price">' + price + '</p>' : '') +
          '</div>' +
        '</a>' +
      '</article>';
    }
    container.innerHTML = html;
  }

  function restoreSearchDefaults(section) {
    var defaults = section.__odditSearchDefaults;
    if (!defaults) return;
    var suggestionsList = section.querySelector('.oddit-search__suggestions-list');
    var productList = section.querySelector('.oddit-search__product-list');
    if (suggestionsList) suggestionsList.innerHTML = defaults.suggestions;
    if (productList) productList.innerHTML = defaults.products;
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });

  window.OdditSearchDrawer = {
    open: function () {
      var section = document.querySelector(SECTION_SELECTOR);
      if (section) openSearch(section);
    },
    close: function () {
      var section = document.querySelector(SECTION_SELECTOR);
      if (section) closeSearch(section);
    },
    toggle: function () {
      var section = document.querySelector(SECTION_SELECTOR);
      if (!section) return;
      if (section.classList.contains('is-open')) {
        closeSearch(section);
      } else {
        openSearch(section);
      }
    }
  };
})();
